import { Driver } from "@/types"

import { DetailsSection } from "./DetailsSection"
import { MetaSection } from "./MetaSection"
import { OrdersSection } from "./OrdersSection"
import { StatusSection } from "./StatusSection"

export const DriverDetails = ({ driver }: { driver: Driver }) => {
  return (
    <>
      <StatusSection driver={driver} />
      <MetaSection driver={driver} />
      <DetailsSection driver={driver} />
      <OrdersSection driver={driver} />
    </>
  )
}
